import React from "react";
import Footer from "./footers/Footer";
import Navbar from "./navbars/Navbar";
import WhatsappButton from "../components/WhatsappButton";
import SnackBar from "./snackbar";

const Layout = ({ children }) => {
  return (
    <React.Fragment>
      <SnackBar />
      <Navbar />
      {children}
      <Footer />
      <WhatsappButton />
    </React.Fragment>
  );
};

export default Layout;
